module.exports = "<div>\n  <div class=\"main-panel-report\">\n    <div class=\"container-fluid\">\n      <main>\n        <ui-view></ui-view>\n      </main>\n    </div>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/reporting/reporting_main.html
// module id = 1461
// module chunks = 0